import React from 'react';
import styled from 'react-emotion';

import BaseCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const Checkbox = styled(({ label, disabled, ...props }) => (
  <FormControlLabel
    value={label}
    control={
      <BaseCheckbox
        color="primary"
        classes={{ root: 'baseCheckboxIconColor', checked: 'checked' }}
      />
    }
    label={label}
    disabled={disabled}
    labelPlacement="start"
    {...props}
    classes={{
      label: 'fieldset-checkbox-label',
    }}
  />
))`
  justify-content: space-between;
  flex: 1;
  margin: 0px;
  border: 1px solid ${colors.grey9};
  border-radius: 4px;
  height: 36px;
  margin-top: 8px;
  margin-bottom: 4px;

  .baseCheckboxIconColor.checked {
    color: ${colors.primary};
  }

  & .fieldset-checkbox-label {
    font-family: ${theme.font.family.workSans};
    padding-left: 14px;
    font-size: 14px;
    color: ${({ disabled }) => (disabled ? colors.grey11 : colors.black)};
  }

  & :hover {
    background-color: ${({ disabled }) =>
      disabled ? colors.white : colors.beige};
  }
`;

export default Checkbox;
